import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Translation } from '../../providers/translation';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'error',
  templateUrl: './error.component.html'
})
export class ErrorComponent {
  constructor(private router: Router, private location: Location, private translation: Translation) {}

  ngOnInit() {}

  back() {
    this.location.back();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/error/error.component.ts